import CheckCircleOutlineRoundedIcon from '@mui/icons-material/CheckCircleOutlineRounded'
import DeleteOutlinedIcon from '@mui/icons-material/DeleteOutlined'
import EditRoundedIcon from '@mui/icons-material/EditRounded'
import FileDownloadRoundedIcon from '@mui/icons-material/FileDownloadRounded'
import ReplayOutlinedIcon from '@mui/icons-material/ReplayOutlined'
import { TableCell, Tooltip } from '@mui/material'
import DialogAlert from 'components/Dialog/Alert'
import { useDialog } from 'components/Dialog/hooks/alert.hook'
import React from 'react'
import { NavigateFunction } from 'react-router-dom'
import { useAuthContext } from 'contexts/auth.context'
import { HearingFilterResponse } from 'types/search-hearing.type'
import { hearingFunctionalities } from 'utils/helpers/funcionalidades'
import { StyledIconButton as IconButton } from './styles'

type TableCellGroupProps = {
  data: HearingFilterResponse
  isExcluded: boolean
  isFinalized: boolean
  navigate: NavigateFunction
  onDelete: (hearingId?: number) => void
  onDownload: (hearingId?: number) => void
  onReactivate: (hearingId?: number) => void
}

export const TableCellGroup: React.FC<TableCellGroupProps> = ({
  data,
  isFinalized,
  isExcluded,
  navigate,
  onDelete,
  onDownload,
  onReactivate,
}) => {
  const {
    openDialog: openExcluded,
    handleOpenDialog: handleOpenExcluded,
    handleCloseDialog: handleCloseExcluded,
  } = useDialog()

  const {
    openDialog: openReactivated,
    handleOpenDialog: handleOpenReactivate,
    handleCloseDialog: handleCloseReactivate,
  } = useDialog()

  const { handleHasPermission } = useAuthContext()

  const handleFinalize = (): void => navigate(`/nova-oitiva/${data.idOitiva}/resumo`)

  const handleEdit = (): void => navigate(`/nova-oitiva/${data.idOitiva}`)

  const handleDelete = (): void => {
    onDelete(data.idOitiva)
    handleOpenExcluded()
  }

  const handleReactivate = (): void => {
    onReactivate(data.idOitiva)
    handleOpenReactivate()
  }

  return (
    <>
      {isExcluded ? (
        <>
          <TableCell>{data.nome}</TableCell>
          <TableCell>{data.dataExclusao}</TableCell>
          <TableCell>{data.nomeResponsavel}</TableCell>
        </>
      ) : isFinalized ? (
        <>
          <TableCell>{data.nome}</TableCell>
          <TableCell>{data.numeroCnj}</TableCell>
          <TableCell>{data.dataInclusao}</TableCell>
          <TableCell>{data.nomeResponsavel}</TableCell>
        </>
      ) : (
        <>
          <TableCell>{data.nome}</TableCell>
          <TableCell>{data.documento}</TableCell>
          <TableCell>{data.dataInclusao}</TableCell>
          <TableCell>{data.dataNascimento}</TableCell>
          <TableCell>{data.nomeResponsavel}</TableCell>
        </>
      )}
      <TableCell align='center' sx={{ width: '150px' }}>
        {!isFinalized && !isExcluded && handleHasPermission(hearingFunctionalities.finalizar) && (
          <Tooltip title='Finalizar'>
            <IconButton aria-label='finalize' size='small' onClick={handleFinalize}>
              <CheckCircleOutlineRoundedIcon fontSize='small' />
            </IconButton>
          </Tooltip>
        )}
        {isFinalized && (
          <Tooltip title='Download'>
            <IconButton
              aria-label='download'
              size='small'
              onClick={() => onDownload(data.idOitiva)}
            >
              <FileDownloadRoundedIcon fontSize='small' />
            </IconButton>
          </Tooltip>
        )}
        {isExcluded ? (
          <Tooltip title='Reativar'>
            <IconButton aria-label='reactivate' size='small' onClick={handleOpenReactivate}>
              <ReplayOutlinedIcon fontSize='small' />
            </IconButton>
          </Tooltip>
        ) : (
          <>
            {!isFinalized && !isExcluded && handleHasPermission(hearingFunctionalities.editar) && (
              <>
                <Tooltip title='Editar'>
                  <IconButton aria-label='edit' size='small' onClick={handleEdit}>
                    <EditRoundedIcon fontSize='small' />
                  </IconButton>
                </Tooltip>
                {handleHasPermission(hearingFunctionalities.excluir) && (
                  <Tooltip title='Excluir'>
                    <IconButton aria-label='delete' size='small' onClick={handleOpenExcluded}>
                      <DeleteOutlinedIcon fontSize='small' />
                    </IconButton>
                  </Tooltip>
                )}
              </>
            )}
          </>
        )}
      </TableCell>
      <DialogAlert
        title='Excluir'
        contentText='Tem certeza que deseja excluir a oitiva informal?'
        open={openExcluded}
        onSuccess={handleDelete}
        onClose={handleCloseExcluded}
      />
      <DialogAlert
        title='Reativar'
        contentText='Tem certeza que deseja reativar a oitiva excluída?'
        open={openReactivated}
        onSuccess={handleReactivate}
        onClose={handleCloseReactivate}
      />
    </>
  )
}
